<script setup lang="ts">
import { Workshop } from '@/@types/workshop'
import image from '@/assets/show/image.webp'
import { Button } from '@/components/ui/button'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogOverlay, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { formatDateFull } from '@/helpers/format-date'
import { Link } from '@inertiajs/vue3'
import { Calendar, Printer, Ticket } from 'lucide-vue-next'
import { ref } from 'vue'

defineProps<{
    workshop: Workshop
    upgraded_mailings: String[]
}>()

const dialog_upgraded_mailings = ref(false)
</script>

<template>
    <Card class="divide-y lg:p-6">
        <CardHeader>
            <div class="flex flex-col justify-between gap-4 md:flex-row">
                <div class="flex items-center gap-4">
                    <img :src="image" class="h-26 w-26 rounded-full" />
                    <div class="flex flex-col">
                        <CardTitle class="text-lg text-gray-800 lg:text-2xl">{{ workshop.description }}</CardTitle>
                        <CardDescription class="text-base text-gray-600">
                            <div class="flex gap-2 text-sm lg:text-base">
                                <Calendar />
                                {{ formatDateFull(workshop.start, $i18n.locale) }}
                                -
                                {{ formatDateFull(workshop.end, $i18n.locale) }}
                            </div>
                        </CardDescription>
                    </div>
                </div>
                <div class="flex gap-6">
                    <Dialog :open="dialog_upgraded_mailings" @update:open="dialog_upgraded_mailings = $event" v-if="upgraded_mailings.length">
                        <DialogOverlay class="z-60" />
                        <DialogTrigger class="hover:text-destructive h-fit cursor-pointer text-gray-400">
                            <Button variant="outline" type="button"><Ticket />{{ $t('Promoted tickets') }}</Button>
                        </DialogTrigger>
                        <DialogContent>
                            <DialogHeader>
                                <DialogTitle>{{ $t('Promoted tickets') }}</DialogTitle>
                                <DialogDescription>{{ $t('Tickets that have been upgraded to a higher category.') }}</DialogDescription>
                            </DialogHeader>
                            <div class="flex flex-col gap-6 pt-6">
                                <p v-for="upgraded_mailing_email in upgraded_mailings"><strong>Email:</strong> {{ upgraded_mailing_email }}</p>
                            </div>
                        </DialogContent>
                    </Dialog>

                    <form action="/admin/csv_exports/merged" method="get">
                        <input type="hidden" name="workshop_id" :value="workshop.id" />
                        <Button variant="outline" type="submit"><Printer />{{ $t('Export') }}</Button>
                    </form>
                    <form action="/admin/csv_exports/abandoned_carts" method="get">
                        <input type="hidden" name="workshop_id" :value="workshop.id" />
                        <Button variant="outline" type="submit">{{ $t("Export abandoned carts") }}</Button>
                    </form>

                    <Button :as="Link" :href="`/admin/mailings?workshop_id=${workshop.id}`">Limpar filtros</Button>
                </div>
            </div>
        </CardHeader>
        <slot />
    </Card>
</template>
